export class RestorePassword {
  public email: string;
  public password: string;
  public passwordRepeat: string;
  public hashId: string;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/restore-password/restore-password.ts